import * as React from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { IconButton, Typography } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ContentPasteRoundedIcon from '@mui/icons-material/ContentPasteRounded';
import colors from 'constants/colors';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '9rem',
    width: '6rem',
});

const Text = styled(Typography)({
    fontSize: 14,
    color: colors.lightblue,
    fontWeight: 400,
    marginTop: 11,
    marginBottom: 22,
    textAlign: 'center',
    maxWidth: '100%', // Ensure text doesn't overflow its container
    whiteSpace: 'nowrap', // To prevent text from wrapping unexpectedly
    overflow: 'hidden', // Hide overflowed content
});

const styles = {
    roundedIconContainer: {
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 46,
        height: 46,
    },
};

export default function QuickAction() {
    const navigate = useNavigate();
    return (
        <div style={{ marginTop: 12 }}>
            <Stack direction="row" spacing={0}>
                <Container>
                    <IconButton onClick={() => navigate(routes.announcements.new)}>
                        <Item style={styles.roundedIconContainer}>
                            <NotificationsIcon htmlColor={colors.darkblue} />
                        </Item>
                    </IconButton>
                    <Text>
                        Send
                        <br />
                        Announcements
                    </Text>
                </Container>
                {/* Send Money quick action temporarily hidden — restore with routes.sendmoney.main */}
                <Container>
                    <IconButton onClick={() => navigate(routes.sendinvoice.main)}>
                        <Item style={styles.roundedIconContainer}>
                            <ContentPasteRoundedIcon htmlColor={colors.darkblue} />
                        </Item>
                    </IconButton>
                    <Text>
                        Send <br />
                        Invoice
                    </Text>
                </Container>
                {/* <Container >
                    <IconButton onClick={() => navigate(routes.qr.main)}>
                        <Item style={styles.roundedIconContainer}>
                            <QrCode2Icon htmlColor={colors.darkblue} />
                        </Item>
                    </IconButton>
                    <Text>View <br /> QR Code</Text>
                </Container> */}
            </Stack>
        </div>
    );
}
